import $ from "jquery";

let timeoutId = null;

/**
 * initializes the events for search functionality
 *
 */
export function initSearch() {

  const search = $("form.cm-search--form");
  const searchIcon = $("i", search);
  const input = $("input.cm-search__form-input", search);

  const showAllSearchResults = $(".cm-search--results .cm-search__pagination a.showContent");
  const showLessSearchResults = $(".cm-search--results .cm-search__pagination a.hideContent");

  input.on("keyup", handleAutocomplete);
  input.on("keydown", handleAutocompleteKeyNav);

  searchIcon.on("click", () => {
    search.submit();
  });

  showAllSearchResults.on("click", (ev) => {
    handleSearchResults(ev, ".hideContent");
    $(window).trigger("resize");
  });

  showLessSearchResults.on("click", (ev) => {
    handleSearchResults(ev, ".showContent");
  });
}

/**
 * Handles the AJAX-Request for the autocomplete suggestion
 * @param requestUrl - String
 * @param queryParam - String
 */
function handleRequest(requestUrl, queryParam) {

  const url = requestUrl + "&query=" + queryParam;

  $.ajax({
    url: url,
    type: "get",
    dataType: "json",
    success: function(response) {
      const autocomplete = $("form.cm-search--form ul.autocomplete");
      autocomplete.empty();

      response.forEach((res) => {
        autocomplete.append("<li data-value='" + res.value +"'>" + res.value + "</li>");
      });

      $("li", autocomplete).bind("click", (ev) => {
        const target = $(ev.currentTarget);
        let value = target.data("value");
        target.closest("form").find("input.cm-search__form-input").val(value);
        target.closest("form").submit();
      });
    }
  });
}

/**
 * handles the behaviour for the search autocomplete
 * @param ev
 */
function handleAutocomplete(ev) {
  if ([40, 38, 13].indexOf(ev.keyCode) == -1) {
    const target = $(ev.currentTarget);
    let requestUrl = target.data("suggestion");
    let queryParam = target.val();
    target.data("queryParam", queryParam);
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => handleRequest(requestUrl, queryParam), 500);
  }
}

/**
 * sets the input value to the given target data-value attr
 * @param target - jQuery Object
 */
function setValue(target, input) {
  let value = target.data("value");
  if (typeof(value) !== 'undefined') {
    input.val(value);
  } else {
    input.val(input.data("queryParam"));
  }
}

/**
 * handles the behaviour for the key navigatin of the autocomplete
 * @param ev
 */
function handleAutocompleteKeyNav(ev) {
  const target = $(ev.currentTarget);
  const autocomplete = target.closest("form.cm-search--form").find("ul.autocomplete");
  let currentFocus = $("li.active", autocomplete);
  let newFocus;

  if (ev.keyCode == 40) {
    // Down key
    if (currentFocus.length != 0) {
      newFocus = currentFocus.next();
    } else {
      newFocus = $("li", autocomplete).first();
    }
    currentFocus.removeClass("active");
    newFocus.addClass("active");
    setValue(newFocus, target);
  } else if (ev.keyCode == 38) {
    // Up key
    if (currentFocus.length != 0) {
      newFocus = currentFocus.prev();
    } else {
      newFocus = $("li", autocomplete).last();
    }
    currentFocus.removeClass("active");
    newFocus.addClass("active");
    setValue(newFocus, target);
  } else if (ev.keyCode == 13) {
    // Enter key
    currentFocus.click();
  }
}

/**
 * handles Click events for SearchResults show more
 * @param ev - EventHandler
 * @param selector - String
 */
function handleSearchResults(ev, selector) {
  ev.preventDefault();
  const target = $(ev.currentTarget);
  const searchResults = target.closest(".cm-search__results").find(".cm-search-result__item").not(".initShown");

  target.siblings().fadeToggle();
  searchResults.slideToggle();
  target.siblings().find(selector).toggle();
  target.toggle();
}
